// extracted by mini-css-extract-plugin
export default {"container":"UA-z","dimension":"VA-z","dimensionLabels":"WA-z"};